import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import {SynchronizationService} from './synchronization.service';
import {ConfigLoaderService} from '../config/configloader.service';

@Injectable()
export class OAuth2Service {
  private baseURL: string;
  constructor(private http: HttpClient, private router: Router,
    private synchronizationService: SynchronizationService,
    private configService: ConfigLoaderService) {
    this.baseURL = `${this.configService.settings.pyWallServer.url}`;
  }

  getAuthorizationUri(): void{
    this.http.get(this.baseURL + 'login/oAuth2', {responseType: 'text'}).subscribe((response: string) => {
      window.location.href = response;
    });
  }

  saveAccessToken(data): void{
    if (data['access_token']){
      localStorage.setItem('aWallOAuthAccessToken', data['access_token']);
    }
    this.router.navigate(['/taskboard']);
  }
  Logout(): void{
    this.deleteAccessToken();
    this.router.navigate(['/login']);
  }
  getAccessToken(): string{
    return localStorage.getItem('aWallOAuthAccessToken');
  }
  isLoggedIn(): boolean {
    return this.getAccessToken() !== null;
  }
  deleteAccessToken(): void {
    localStorage.removeItem('aWallOAuthAccessToken');
  }
}
